import { render } from "./TagisLakas.vue?vue&type=template&id=30d0badd"
import script from "./TagisLakas.vue?vue&type=script&lang=js"
export * from "./TagisLakas.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__